import { useMemo } from "react";

const CryptoJS = require("crypto-js");
const val = "@best.WORK_";

export const useCrypto = () => {

    const methods = useMemo(() => {
        const decrypt = (value) => {
            let reb64 = CryptoJS.enc.Hex.parse(value);
            let bytes = reb64.toString(CryptoJS.enc.Base64);
            let decrypt = CryptoJS.AES.decrypt(bytes, val);
            let plain = decrypt.toString(CryptoJS.enc.Utf8);
            return plain;
        };

        const encrypt = (value) => {
            let b64 = CryptoJS.AES.encrypt(value, val).toString();
            let e64 = CryptoJS.enc.Base64.parse(b64);
            let eHex = e64.toString(CryptoJS.enc.Hex);
            return eHex;
        };

        return {
            encrypt,
            decrypt,
        };
    }, []);

    return methods;
};